import { metricTestNodesActionTypes } from './../actions/types';

const initialState = [];

const metricTestNodes = (state = initialState, action) => {
  switch (action.type) {
    case metricTestNodesActionTypes.success:
      return [
        ...action.response
      ];
    default:
      return state;
  }
};

export default metricTestNodes;

export const getMetricTestNodes = state => state.metricTestNodes;


// WEBPACK FOOTER //
// src/reducers/metricTestNodes.js